const modules = import.meta.glob([
  '~/partials/erb_wrappers/ErbDemoDayBanner.jsx',
], { eager: true })

export default modules
